// extracted by mini-css-extract-plugin
export default {"sidenavigation":"Approval_sidenavigation__xTMo1","form-width":"Approval_form-width__4xphp"};